<div id="head_wrap">
    <div id="closeBtn">
        <span  (click)="close();">×</span>
    </div>

    <h1 id="title">{{report.reports[currentIndex].name}}分析报告</h1>
</div>

<div id="wrap">
    <div id="report">

        <div id="bottleWrap">
            <div class="bottleItem" [ngClass] ="{'hide':!isFirstReport,'not_hide':isFirstReport}" id="bottleItemOnlyOne">
                <div class="bottlePicture">
                    <div class="stars">
                        <svg width="100%" height="100%" viewBox="0 0 70 100" version="1.1" xmlns="http://www.w3.org/2000/svg" id="onlyFirstStarsSvg" xmlns:xlink="http://www.w3.org/1999/xlink">

                        </svg>
                    </div>
                </div>
                <div class="bottleText">第一次练习</div>
            </div>

            <div class="bottleItem" id="bottleItem1" [ngClass] ="{'hide':isFirstReport,'not_hide':!isFirstReport}">
                <div class="bottlePicture">
                    <div class="stars" id="firstStars">
                        <svg width="100%" height="100%" viewBox="0 0 70 100" version="1.1" xmlns="http://www.w3.org/2000/svg" id="firstStarsSvg" xmlns:xlink="http://www.w3.org/1999/xlink">

                        </svg>
                    </div>
                </div>
                <div class="bottleText">第一次练习</div>
            </div>
            <div class="arrow" [ngClass] ="{'hide':isFirstReport,'not_hide':!isFirstReport}">
                <div id="arrowPicture">

                </div>
            </div>
            <div class="bottleItem" id="bottleItem2" [ngClass] ="{'hide':isFirstReport,'not_hide':!isFirstReport}">
                <div class="bottlePicture">
                    <div class="stars" id="nowStars">
                        <svg width="100%" height="100%" viewBox="0 0 70 100" version="1.1" xmlns="http://www.w3.org/2000/svg" id="nowStarsSvg" xmlns:xlink="http://www.w3.org/1999/xlink">

                        </svg>
                    </div>
                </div>
                <div class="bottleText">第{{order}}次练习</div>
            </div>
        </div>

        <div id="starWrap">
            <h2>关键行动指数</h2>
            <ul>
                <li class="starItem">
                    <div class="starItemLeft">
                        说明讨论的目的
                    </div>
                    <div class="starItemRight">
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[0].value>=1,'negativeStar':kas[0].value<1}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[0].value>=2,'negativeStar':kas[0].value<2}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[0].value>=3,'negativeStar':kas[0].value<3}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[0].value>=4,'negativeStar':kas[0].value<4}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[0].value>=5,'negativeStar':kas[0].value<5}"></i>
                    </div>
                </li>
                <li class="starItem">
                    <div class="starItemLeft">
                        促进参与
                    </div>
                    <div class="starItemRight">
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[1].value>=1,'negativeStar':kas[1].value<1}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[1].value>=2,'negativeStar':kas[1].value<2}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[1].value>=3,'negativeStar':kas[1].value<3}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[1].value>=4,'negativeStar':kas[1].value<4}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[1].value>=5,'negativeStar':kas[1].value<5}"></i>
                    </div>
                </li>
                <li class="starItem">
                    <div class="starItemLeft">
                        明确表达绩效挑战
                    </div>
                    <div class="starItemRight">
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[2].value>=1,'negativeStar':kas[2].value<1}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[2].value>=2,'negativeStar':kas[2].value<2}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[2].value>=3,'negativeStar':kas[2].value<3}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[2].value>=4,'negativeStar':kas[2].value<4}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[2].value>=5,'negativeStar':kas[2].value<5}"></i>
                    </div>
                </li>
                <li class="starItem">
                    <div class="starItemLeft">
                        维持动力
                    </div>
                    <div class="starItemRight">
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[3].value>=1,'negativeStar':kas[3].value<1}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[3].value>=2,'negativeStar':kas[3].value<2}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[3].value>=3,'negativeStar':kas[3].value<3}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[3].value>=4,'negativeStar':kas[3].value<4}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[3].value>=5,'negativeStar':kas[3].value<5}"></i>
                    </div>
                </li>
                <li class="starItem">
                    <div class="starItemLeft">
                        提供支持
                    </div>
                    <div class="starItemRight">
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[4].value>=1,'negativeStar':kas[4].value<1}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[4].value>=2,'negativeStar':kas[4].value<2}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[4].value>=3,'negativeStar':kas[4].value<3}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[4].value>=4,'negativeStar':kas[4].value<4}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[4].value>=5,'negativeStar':kas[4].value<5}"></i>
                    </div>
                </li>
                <li class="starItem">
                    <div class="starItemLeft">
                        达成共识
                    </div>
                    <div class="starItemRight">
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[5].value>=1,'negativeStar':kas[5].value<1}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[5].value>=2,'negativeStar':kas[5].value<2}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[5].value>=3,'negativeStar':kas[5].value<3}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[5].value>=4,'negativeStar':kas[5].value<4}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[5].value>=5,'negativeStar':kas[5].value<5}"></i>
                    </div>
                </li>
                <li class="starItem">
                    <div class="starItemLeft">
                        制定行动计划
                    </div>
                    <div class="starItemRight">
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[6].value>=1,'negativeStar':kas[6].value<1}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[6].value>=2,'negativeStar':kas[6].value<2}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[6].value>=3,'negativeStar':kas[6].value<3}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[6].value>=4,'negativeStar':kas[6].value<4}"></i>
                        <i class="fa fa-star fa-lg" [ngClass]="{'activeStar':kas[6].value>=5,'negativeStar':kas[6].value<5}"></i>
                    </div>
                </li>
            </ul>
        </div>

        <!--<button id="detailBtn" (click)="onDetailBtnClick()">{{report.reports[currentIndex].name}}答案解析</button>-->
        <button id="detailBtn" (click)="onDetailBtnClick()">答案解析</button>
        <button id="againBtn" (click)="redo()">再做一次</button>
    </div>

    <div id="prompt" *ngIf="report.allExerciseFinished">
        <div id="prompt_picture">

        </div>
        <!--<p *ngIf="!report.allExerciseFinished">
            下一次情景模拟开放时间：<br/>
            <span>{{report.nextExerciseStartTime}}</span>
        </p>-->
        <p>
            <span>情景模拟已经全部完成！</span>
        </p>
    </div>
</div>

<button id="choiceBtn" *ngIf="(report.allExerciseFinished === false && currentIndex === report.finishedQuizCount + report.finishedExerciseCount - 1)&&status" class="choiceBtn_enable" (click)="startNextCase()">
    <span *ngIf="status==1">下一题</span>
    <span *ngIf="status!=1">案例练习试用已完毕！</span>
</button>

<button id="goToPostSurvey" class="fontSize16 choiceBtn_enable" *ngIf="report.allExerciseFinished == true" (click)="linkToPostSurvey()">
    进入能力考核
</button>

<div id="bigReportAnswer">
    <h1>答案解析</h1>
    <div>
        <div *ngIf="currentIndex==smallReportNumber">
            <div class="fontSize14 lineHeight21">
                恭喜小伙伴走完辅导全程，不容易啊！对自己在这次辅导中的表现满意么？接下来会由本门课程的授课老师亲自为你解析这次辅导的重点和难点。
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21">
                好啦，接下来请听老师讲解。
            </div>
            <audio src="http://video.diaabie.com/bigPracticeOne.wav" controls id="audio"></audio>
            <div class="fontSize14 lineHeight21 report_start">
                ——&nbsp;&nbsp;START&nbsp;&nbsp;——
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21 marginTop0">
                下属到时间交不出东西，或者交出的东西质量不达标，这样的情景是不是你也经常遇到？
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21">
                开始辅导之前，我们已经掌握的重要信息有3条：<br/>
                1.下属之前项目计划性好，没出现过拖延<br/>
                2.专业技能强<br/>
                3.下属知道内部客户并不满意报告
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21">
                我们辅导的目的是为了协助下属意识到迟交及质量不吻合需求背后的原因是什么，所以先入为主、主观臆断是不能解决问题的。在这个案例当中澄清的步骤，通过提问发现真相是最可靠的方法，这样才能对症下药解决问题。回忆一下之前你遇到类似场景你是怎样辅导下属的呢？你有没有落入到
                未经澄清，主观臆断的陷阱当中？
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21">
                同时因为下属自身一直专业技能很强，工作态度认真，但内部客户还是不满意。所以在开始辅导之前，下属心中一定是有抵触的情绪。
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21">
                在这个辅导案例中我们一定要使用KP1：维护自尊、加强自信，例如你可以说：“你以往向来都是准时交付的，是不是有什么特别的原因导致延迟呢？”
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21">
                另外你也要多使用KP2：表达同理心，例如你可以说：“你花了那么多时间帮王经理做报告，他还是有些不满意，你心中一定是委屈的。”这样才能够打消抵触的情绪，让辅导更顺利的往下推进。
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21">
                总结来说，本个辅导案例最重要的就是：第一，不要有预设立场，澄清问题的原因才能对症下药；第二，即便是辅导改善，也要善用KP1、KP2处理下属的情绪，激发他改善的动力。
            </div>

            <div class="fontSize14 lineHeight21 report_end">
                ——&nbsp;&nbsp;END&nbsp;&nbsp;——
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21 endColor">
                另外，你一定非常想知道你得的星星是怎么来的吧？
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21 endColor">
                下面揭晓谜底：<br/>
                -&nbsp;&nbsp;每个关键行动都有2个评价维度，一个是时效性，也就是在什么时候说；一个是话术质量，也就是怎么说。<br/>
                -&nbsp;&nbsp;如果每道题你都是在最佳时机，选了话术最好的选项，最终自然就会得到最高的分数，也就是五颗星。<br/>
                -&nbsp;&nbsp;其他情况就不会是最高分啦，最终根据分数统计，会折算成1到4颗星星。
            </div>
        </div>
        <div *ngIf="currentIndex==smallReportNumber+1">
            <div class="fontSize14 lineHeight21">
                恭喜小伙伴走完辅导全程，真心不容易！面对王立娜这样有资历有能力，但偏偏爱抱怨的老员工，你的辅导成绩如何？
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21">
                现在，请听听导师Mindy对这次辅导的讲解：
            </div>
            <audio src="http://video.diaabie.com/bigPracticeTwo.wav" controls id="audio"></audio>
            <div class="fontSize14 lineHeight21 report_start">
                ——&nbsp;&nbsp;START&nbsp;&nbsp;——
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21">
                在辅导改进的讨论中，最困难的是怎么跟员工谈行为改进的问题。就像这个案例，要解决的问题是下属常常抱怨新系统不好用，而影响了其他人使用的意愿。案例里系统不好用是事实，下属多半会谈到很多不好用的状况。大部分的主管面对这样的情景，会被下属牵着鼻子走：只专注于解决系统的问题，但却忽略了真正要解决的问题是让下属停止抱怨的行为
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21">
                所以在这个案例中，最佳解决方式是：第一，在开启讨论的阶段，需要明确指出不良的行为会对其他人造成什么影响；第二，澄清阶段，深入理解系统不好用的原因在哪里；第三，原因找出来后，针对可以解决的问题，鼓励下属思考他（她）可以做些什么；第四，实际的系统问题得到了改善，那在达成一致阶段，就必须重申你希望下属能够停止抱怨这种不良行为。在讨论过程中，不要忘记适时同理下属，毕竟新系统的确是给对方造成了不便；在讨论方案时，多用开放式问题，促进他（她）的参与，以获得对方改善的承诺
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21">
                回到现实的工作场景里，不论是工作效果欠佳还是行为不良，背后可能都会有很多原因。这些原因也未必都能被解决。所以，身为主管，你应该鼓励下属聚焦在可解决的问题上，思考自己可以做些什么以改进自己的绩效或行为。
            </div>
            <div class="fontSize14 lineHeight21 report_end">
                ——&nbsp;&nbsp;END&nbsp;&nbsp;——
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21 endColor">
                另外，你一定非常想知道你得的星星是怎么来的吧
            </div>
            <div class="smallReportAnswerWord fontSize14 lineHeight21 endColor">
                下面揭晓谜底：<br/>
                -&nbsp;&nbsp;每个关键行动都有2个评价维度，一个是时效性，也就是在什么时候说；一个是话术质量，也就是怎么说。<br/>
                -&nbsp;&nbsp;如果每道题你都是在最佳时机，选了话术最好的选项，最终自然就会得到最高的分数，也就是五颗星。<br/>
                -&nbsp;&nbsp;其他情况就不会是最高分啦，最终根据分数统计，会折算成1到4颗星星。
            </div>
        </div>
    </div>
</div>
<div id="closeBtnReport2" (click)="onCloseBtnReportClick()"></div>

<div id="shade"></div>

<app-report-list-button [reports]="report.reports" (onSwitchReport)="switchReport($event);"></app-report-list-button>



// WEBPACK FOOTER //
// ./src/app/case-practice-report-big/case-practice-report-big.component.html